import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Group, Loader, Select, Stack, Text } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { AppModal } from "../../shared/AppModal";
import { useContext, useMemo, useState } from "react";
import { useGetOrganizationListQuery } from "../../graphql/graphql";
import { ImageWithPlaceholder } from "../../shared/ImageWithPlaceholder";
import { showErrorNotification } from "../../shared/Notifications";
import { AppContext } from "../../shared/PrivateRoutes";
import { MasqueradeToOrganizationSchema } from "./MasqueradeToOrganizationModal.validation";
/*************************************************************
 * THIS IS ONLY EVER INTENDED TO BE USED BY THERAPPROVE ADMINS
 *************************************************************/
export const MasqueradeToOrganizationModal = ({ opened, close, onSubmit }) => {
    const { isTherapproveAdmin, originalOrganizationId } = useContext(AppContext);
    const [isRequesting, setIsRequesting] = useState(false);
    const form = useForm({
        mode: "controlled",
        initialValues: { organizationId: originalOrganizationId || null },
        validate: yupResolver(MasqueradeToOrganizationSchema)
    });
    const [{ data, fetching }] = useGetOrganizationListQuery({
        pause: !opened || !isTherapproveAdmin
    });
    const organizations = useMemo(() => {
        return (data?.organizations?.organizationList
            ?.map((org) => {
            if (!org)
                return null;
            return {
                value: org.value,
                label: org.label
            };
        })
            .filter((item) => item !== null) ?? []);
    }, [data]);
    const organizationImageUrls = useMemo(() => {
        return data?.organizations?.organizationList?.map((org) => {
            if (!org)
                return null;
            return {
                [org.value]: {
                    imageUrl: org.imageUrl
                }
            };
        });
    }, [data]);
    const submitMasqueradeToOrganization = async (event) => {
        event.preventDefault();
        const valid = form.validate();
        if (valid.hasErrors)
            return;
        const formValues = form.getValues();
        if (!formValues.organizationId)
            return;
        try {
            setIsRequesting(true);
            onSubmit(formValues.organizationId);
        }
        catch (error) {
            console.error(error);
            showErrorNotification();
        }
        finally {
            setIsRequesting(false);
            handleClose();
        }
    };
    const handleClose = () => {
        close();
        form.reset();
    };
    return (_jsx(AppModal, { title: "Masquerade To Organization", opened: opened, onClose: handleClose, onSubmit: submitMasqueradeToOrganization, children: _jsxs(Stack, { gap: "md", children: [_jsx(Select, { required: true, label: "Organization", placeholder: "Organization", clearable: true, searchable: true, disabled: !isTherapproveAdmin, checkIconPosition: "right", rightSection: fetching ? _jsx(Loader, { size: 16 }) : null, data: organizations, ...form.getInputProps("organizationId"), renderOption: (option) => {
                        const imageObject = organizationImageUrls?.find((org) => org &&
                            Object.keys(org)[0] === option.option.value)?.[option.option.value];
                        return (_jsxs(Group, { flex: "1", gap: "xs", children: [_jsx(ImageWithPlaceholder, { imageUrl: imageObject?.imageUrl, avatarText: option.option.label, size: 24 }), _jsx(Text, { variant: "body", size: "sm", children: option.option.label })] }));
                    } }), _jsx(Flex, { justify: "flex-end", children: _jsx(Button, { variant: "filled", loading: isRequesting, onClick: submitMasqueradeToOrganization, children: "Masquerade" }) })] }) }));
};
